import React, { FC, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useMachine } from "../../context/MachineContext";
import { getOrganizationByUuid } from "../../repositories/OrganizationRepository";
import { IOrganization } from "../../types/Organization";
import { useUser } from "../../context/UserContext";

const Header: FC = () => {
  const [organization, setOrganization] = useState<Partial<IOrganization>>({});

  const { user } = useUser();
  // const { machine, clearMachine } = useMachine();
  // const navigate = useNavigate();

  // const toggleNotifications = () => {
  //   setIsNotificationsOpen(!isNotificationsOpen);
  // };

  useEffect(() => {
    if (!user?.organizationUuid) return;
    getOrganizationByUuid(user.organizationUuid)
      .then(setOrganization)
      .catch(() => {});
  }, [user?.organizationUuid]);

  return (
    <div className="header">
      <div></div>
      {/*{!!machine && (
        <div
          className="machine-name"
          onClick={() => {
            clearMachine();
            navigate("/machines");
          }}
        >
          {machine.name}
        </div>
      )}*/}
      {!!user && (
        <div className="dashboard-header-controls">
          <div className="user-info">
            <div>{user.fullName}</div>
            {organization.name && (
              <div className="organization-name">{organization.name}</div>
            )}
          </div>
          <img
            className="avatar"
            src={
              !user.avatar
                ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQH41aGz2eaeJbKuRNAawocn9ummGUZovlfGg&s"
                : user.avatar
            }
            alt="Avatar"
          />
        </div>
      )}
    </div>
  );
};

export default Header;
